//Imports
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import { Button, Modal, TableView } from "@gpstrackit/gtc-react-controls";

//Actions
import { transactionsSummarySearchTransactions, reset } from "./redux/slice";

//Styles
import './index.scss'

const TransactionsSummary = () => {

    //Redux
    const dispatch = useDispatch();

    //Redux States
    const { open, loading, transactionId, nextToken, result } = useSelector((state) => state.transactionsSummaryRedux);

    //Local States
    const [data, setData] = useState([])

    //Language
    const { messages } = useIntl();

    useEffect(() => {
        if (open && transactionId) {
            dispatch(transactionsSummarySearchTransactions({
                transactionId,
                nextToken
            }))
        }
    }, [open, transactionId])

    const handleClose = () => {
        dispatch(reset())
        setData([])
    }

    useEffect(() => {
        if (result?.length && open) {
            let resume = [];
            result?.forEach((data) => {
                let dataCustomer = JSON.parse(JSON.parse(data.Data));
                resume.push({
                    name: dataCustomer?.Name,
                    ein: dataCustomer?.EIN,
                    contactName: dataCustomer?.ContactName,
                    email: dataCustomer?.Email,
                    phone: dataCustomer?.Phone,
                    countryCode: dataCustomer?.CountryCode,
                    notifyByEmail: dataCustomer?.NotifyByEmail,
                    notifyByPhone: dataCustomer?.NotifyByPhone,
                    locationName: dataCustomer?.LocationName,
                    City: dataCustomer?.City,
                    State: dataCustomer?.City,
                    tags: dataCustomer?.Tags,
                    status: data.State,
                    error: data.ErrorMessage
                });
            });
            setData([...data, ...resume]);
            if (nextToken) {
                dispatch(transactionsSummarySearchTransactions({ transactionId, nextToken }))
            }
        }
    }, [result])

    return (
        <Modal
            title={messages['transactions_title']}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secundary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["close"]}
                    </Button>
                    <Button
                        variant="primary"
                        style={{ marginRight: "5px" }}
                        onClick={() => {
                            dispatch(transactionsSummarySearchTransactions({
                                transactionId,
                                nextToken: null
                            }))
                            setData([])
                        }}
                        isDisabled={loading}
                    >
                        {messages["transactions_refresh"]}
                    </Button>
                </div>
            }
        >
            <div className="transactions-summary-container">
                <TableView
                    data={data || []}
                    loading={loading}
                    hidePagination
                    disableItemSelection
                    topheight={130}
                    columns={[
                        {
                            key: "name",
                            title: messages['transactions_customer'],
                            show: true,
                            width: 150,
                            render: (row) => <span>{row?.name}</span>
                        },
                        {
                            key: "status",
                            title: messages['transactions_status'],
                            show: true,
                            width: 150,
                            render: (row) => <span>{row?.status}</span>
                        },
                        {
                            key: "error",
                            title: messages['transactions_error'],
                            show: true,
                            width: 200,
                            render: (row) => <span>{row?.error}</span>
                        }
                    ]}
                />
            </div>
        </Modal>
    );
};

export default TransactionsSummary;